module.exports = __webpack_public_path__ + "img/Group 8675.44ded72b.svg";